import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { useMultiStyleConfig as e, chakra as c, Box as n } from "@chakra-ui/react";
import { CircleExclamationIcon as l } from "../../icons/componentIcons.mjs";
const f = ({ children: s, ...t }) => {
  const r = e("FormError");
  return /* @__PURE__ */ i(c.div, { __css: r.text, ...t, children: [
    /* @__PURE__ */ o(l, { variant: "solid", size: "xl", sx: r.icon }),
    /* @__PURE__ */ o(n, { children: s })
  ] });
};
export {
  f as ErrorMessage
};
